import React, { useContext, useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { emptyText } from '@mummssoftware/utils/constants';
import {
  OrdersGlobalContext,
  SET_NOTE_TEXT,
} from '@mummssoftware/global-context/OrdersGlobalContext';
import { useStyles } from '../style/style';
import defaults from '../../translations/en.json';

export const OrderNote = () => {
  const classes = useStyles();
  const { createOrder, dispatchOrders } = useContext(OrdersGlobalContext);
  const [noteInputText, setNoteInputText] = useState<string>(emptyText);

  const handleChange = (event: any) => {
    const { value: nextValue } = event.target;
    setNoteInputText(nextValue);
  };

  // when saving the note, get the text
  useEffect(() => {
    if (createOrder) {
      if (noteInputText !== emptyText) {
        dispatchOrders({
          type: SET_NOTE_TEXT,
          payload: noteInputText,
        });
      }
    }
  }, [createOrder]);

  return (
    <TextField
      id="order-note"
      name="editableNote"
      placeholder={defaults.textArea}
      minRows={2}
      maxRows={90}
      onChange={handleChange}
      value={noteInputText}
      variant="outlined"
      multiline
      InputProps={{
        classes: {
          input: classes.inputFieldHeight,
          root: classes.orderNoteField,
        },
      }}
      classes={{
        root: classes.orderNoteField,
      }}
    />
  );
};
